import { createFileRoute } from '@tanstack/react-router';
import EventLanding from 'src/pages/Organization/Event/Landing';

export const Route = createFileRoute('/$organizationSlug/events/$eventId/$')({
  component: EventLanding,
});
